// File: /opt/dev_environment/assets/workspace/app-init/src/components/UserMenu/UserMenu.js

import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import ProfileModal from './ProfileModal';
import './UserMenu.css';

function UserMenu() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isOpen]);

  const handleLogout = useCallback(async () => {
    setIsOpen(false);
    await logout();
    navigate('/login');
  }, [logout, navigate]);

  const handleOpenProfile = useCallback(() => {
    setIsOpen(false);
    setShowProfile(true);
  }, []);

  const handleCloseProfile = useCallback(() => {
    setShowProfile(false);
  }, []);

  const displayName = user?.full_name || user?.email?.split('@')[0] || 'User';
  const initials = displayName.charAt(0).toUpperCase();

  return (
    <>
      <div className="user-menu" ref={menuRef}>
        <button
          className={`user-menu__trigger ${isOpen ? 'user-menu__trigger--open' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Benutzermenü"
          aria-expanded={isOpen}
          type="button"
        >
          <div className="user-menu__avatar">
            {initials}
          </div>
          <span className="user-menu__name">
            {displayName}
          </span>
          <svg className="user-menu__chevron" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 10l5 5 5-5z" />
          </svg>
        </button>

        {isOpen && (
          <div className="user-menu__dropdown">
            <div
              className="user-menu__user-info"
              onClick={handleOpenProfile}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter') handleOpenProfile(); }}
            >
              <div className="user-menu__user-name">{displayName}</div>
              <div className="user-menu__user-email">{user?.email}</div>
              <div className="user-menu__user-info-hint">
                <span role="img" aria-hidden="true">✏️</span>
                Profil bearbeiten
              </div>
            </div>

            <button
              className="user-menu__item user-menu__item--danger"
              onClick={handleLogout}
              type="button"
            >
              <span className="user-menu__item-icon" role="img" aria-hidden="true">🚪</span>
              Abmelden
            </button>
          </div>
        )}
      </div>

      {/* Profile Modal */}
      {showProfile && (
        <ProfileModal onClose={handleCloseProfile} />
      )}
    </>
  );
}

export default UserMenu;